console.log("utils.js added")
import moment from "moment";
// utils.js
export default {
  install(Vue) {
        Vue.prototype.$saludar =()=>{
            return 'hola'
        }

        // FORMATO
        
        Vue.prototype.$getStringHorasMinutos =(tiempo)=>{
          if(tiempo){
            const horas = Math.floor(tiempo / 60);
            const minutos = tiempo % 60;
            return `${horas}h ${minutos}m`
          }else{
            return null
          }
        }
        
     
      // Puedes añadir más funciones genéricas aquí si es necesario
    }
  };